import Footer from "@/components/Footer";
import { Dimmer } from "@/components/spinner";
import useTableService from "@/components/useTableServerSide";
import { SearchInput } from "@/ui/inputs/Input";
import { Mensaje } from "@/components/mensajes2";
import { Toasts } from "@/components/toasts";
import { ContribuyenteInmueble } from "./modalContribuyenteInmueble";
import ModalActualizarAvaluo from "./modalActualizarAvaluo";
import React, { useEffect, useRef, useState } from "react";
import logoac from "@/imagenes/lg_inmuebles.png";
import axios from "axios";

export default function TablaInmueble() {
  const token = localStorage.getItem("jwtToken");
  const permiso = JSON.parse(localStorage.getItem("accinmueble"));
  const op = require("@/modulos/datos");
  const searchTimeoutRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCard, setLoadingCard] = useState(false);
  const [activate, setActivate] = useState(false);
  const [totales, setTotales] = useState({
    activos: 0,
    inactivos: 0,
    total: 0,
  });

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [valorUT, setValorUT] = useState();
  const [configInmueble, setConfigInmueble] = useState();
  const [np, setNp] = useState(0);
  const [prd, setPrd] = useState(0);
  const [declaWeb, setDeclaWeb] = useState(false);
  const [espiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [anioActu] = useState(localStorage.getItem("anioactu"));
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));

  const [mostrarModal, setMostrarModal] = useState(false);
  const [mostrarModalAvaluo, setMostrarModalAvaluo] = useState(false);
  const [inmueble, setInmueble] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [multas, setMultas] = useState();
  const [avaluo, setAvaluo] = useState();
  const [usoTerreno, setUsoTerreno] = useState({
    idvalorfiscalxusoterreno: 0.0,
    usoterreno: "",
    idvalorfiscconstruc: 0.0,
  });
  const [valorConstruccion, setValorConstruccion] = useState({
    idvalorfiscconstruc: 0.0,
    descripcion: "",
    porcentajeconstruc: 0.0,
  });
  const [options, setOptions] = useState();
  const [facturaR, setFacturaR] = useState();
  const [credito, setCredito] = useState();
  const [idValor, setIdValor] = useState();

  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });

  const cardsData = [
    {
      title: "Inmuebles Registrados",
      value: totales.total,
      color: "#053160",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () =>
        imprimirReporte(
          " status in(61,62,63,0) ",
          "Lista de Inmuebles Registrados",
        ),
    },
    {
      title: "Inmuebles Activos",
      value: totales.activos,
      color: "#76b8e8",
      icon: "fas fa-toggle-on fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () =>
        imprimirReporte(" status = 61 ", "Lista de Inmuebles Activos"),
    },
    {
      title: "Inmuebles Inactivos",
      value: totales.inactivos,
      color: "#4e80b1",
      icon: "fas fa-toggle-off fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () =>
        imprimirReporte(" status != 61 ", "Lista de Inmuebles Inactivos"),
    },
  ];

  const headCells = [
    {
      id: "idinmueble",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "numficha",
      label: "N° FICHA",
      width: "70px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombrepropie",
      label: "NOMBRE PROPIETARIO",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "dirinmueble",
      label: "DIRECCION",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "codigocatastral",
      label: "CODIGO CATASTRAL",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "cedulapropie",
      label: "CEDULA PROPIETARIO",
      width: "120px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  const buscarRegistros = () => {
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      orderBy: tableState.orderBy,
      orderDir: tableState.orderDir,
      search: tableState.search,
    };
    const endpoint = `${op.conexion}/api/catalogo/inmueblesPaginacion`;
    const controller = new AbortController();

    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  };

  const buscarRegistrosCartas = () => {
    try {
      setLoadingCard(true);
      const campos = `
        count(case when status = 61 then 1 end) as activos,
        count(case when status != 61 then 1 end) as inactivos,
        count(*) as total
      `;
      const tabla = `inmueble`;
      const orden = "1";
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${tabla}&orden=${orden}`;

      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.status === 200 && res.data) {
            const { activos, inactivos, total } = res.data[0];
            setTotales({ activos, inactivos, total });
          }
        })
        .catch(() => {
          setMensaje({
            mostrar: true,
            titulo: "ERROR",
            texto: "Error al Buscar los Registros",
            icono: "error",
          });
        })
        .finally(() => setLoadingCard(false));
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar los Registros de las Cartas",
        icono: "error",
      });
    }
  };

  const seleccionarConfiguracion = () => {
    const endpoint = `${op.conexion}/api/industria/configuracionindustria`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setDeclaWeb(response.data.declaweb);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error de configuración",
          icono: "error",
        });
      });
  };

  const seleccionarValorPetro = () => {
    const endpoint = `${op.conexion}/api/efiscal/valorpetro`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setValorUT(response.data.valor);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error al obtener valor",
          icono: "error",
        });
      });
  };

  const seleccionarConfigInmueble = () => {
    const campos = "*";
    const nomtab = "configinmueble";
    const orden = "1";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          setConfigInmueble(response.data[0]);
          switch (parseInt(response.data[0].periodopago)) {
            case 1:
              setNp(1);
              setPrd(12);
              break;
            case 2:
              setNp(4);
              setPrd(3);
              break;
            case 3:
              setNp(12);
              setPrd(1);
              break;
          }
        }
      })
      .catch((error) => {
        setConfigInmueble(null);
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error de configuración",
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = (opti, idinmueble, permisoStr) => (e) => {
    e.preventDefault();

    if (permisoStr === "1") {
      const campos = "*";
      const nomtab = "inmueble";
      const nomid = "idinmueble";
      const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;

      setActivate(true);

      axios
        .get(endpoint, {
          headers: { "x-access-token": `${token}` },
        })
        .then(function (response) {
          if (response.status === 200 && response.data) {
            setInmueble(response.data);

            if (opti === 5) {
              setActivate(false);
              if (parseInt(response.data.idclaseterreno) > 0) {
                setMostrarModalAvaluo(true);
              } else {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto:
                    "No se puede Actualizar el Avaluo \n el Contribuyente no tiene asignado la clase del terreno \n debe Acudir a Catastro.",
                  icono: "error",
                });
              }
            } else {
              setCredito(response.data.credito);
              setOptions(opti);
              seleccionarDeuda(response.data);
            }
          }
        })
        .catch((error) => {
          setMensaje({
            mostrar: true,
            titulo: "ERROR",
            texto: error.response?.data?.message || "Error al consultar",
            icono: "error",
          });
          setActivate(false);
        });
    } else {
      setToast({
        mostrar: true,
        mensaje:
          opti === 1
            ? "No posee permiso para Consultar"
            : opti === 2
              ? "No posee permiso para Editar"
              : opti === 3
                ? "No posee permiso para Eliminar"
                : "No posee permiso para esta acción",
        titulo: "Alerta.",
      });
    }
  };

  const seleccionarDeuda = (data) => {
    const endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${data.idinmueble}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=1`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          const deu = [];
          const his = [];

          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace(/'/g, ""),
                monto: parseFloat(response.data[i].mondeu),
                intereses: parseFloat(response.data[i].intmoradeu),
                recargo: parseFloat(response.data[i].recargodeu),
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace(/'/g, ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }
          setDeuda(deu);
          setHistorico(his);
        }
        seleccionarMultas(data);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error al consultar deuda",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarMultas = (data) => {
    const campos = "*";
    const tabla = "multa";
    const nombreid = "idcontribuyente";
    const nombreid2 = "tablacontribuyente";
    const valorid2 = "inmueble";
    const nombreid3 = "tipoimpuesto";
    const valorid3 = "INMUEBLES URBANOS";
    const endpoint = `${op.conexion}/api/consulta/modeli3string?campos=${campos}&id=${data.idinmueble}&nomtab=${tabla}&nomid=${nombreid}&nomid2=${nombreid2}&id2=${valorid2}&nomid3=${nombreid3}&id3=${valorid3}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMultas(response.data);
        }
        seleccionarAvaluo(data);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error al consultar multas",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarAvaluo = (data) => {
    const endpoint = `${op.conexion}/api/inmueble/avaluo?idinmueble=${data.idinmueble}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setAvaluo(response.data);
        }
        seleccionarTipoUso(data);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error al consultar avalúo",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarTipoUso = (data) => {
    const endpoint = `${op.conexion}/api/inmueble/tipouso?tipouso=${data.usoconstruccion}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          setUsoTerreno(response.data);
          seleccionarValorConstruccion(
            response.data[0]?.idvalorfiscconstruc,
            data,
          );
        } else {
          seleccionarFacturas(data);
        }
      })
      .catch(function () {
        seleccionarFacturas(data);
      });
  };

  const seleccionarValorConstruccion = (id, data) => {
    if (!id) {
      seleccionarFacturas(data);
      return;
    }

    const campos = "*";
    const nomtab = "valorfiscconstruc";
    const nomid = "idvalorfiscconstruc";
    const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setValorConstruccion(response.data);
          setIdValor(response.data.idvalorfiscconstruc);
        }
        seleccionarFacturas(data);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al consultar valor construcción",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarFacturas = (data) => {
    const nomtab = "inmueble";
    const endpoint = `${op.conexion}/api/inmueble/relacionfacturas?idinmueble=${data.idinmueble}&nomtab=${nomtab}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setFacturaR(response.data);
          setActivate(false);
          setMostrarModal(true);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error al consultar facturas",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const cerrarModal = () => {
    setMostrarModal(false);
  };

  const cerrarModalAvaluo = () => {
    setMostrarModalAvaluo(false);
  };

  const cerrarToast = () => {
    setToast({ ...toast, mostrar: false });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);

    if (value.length === 0) {
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    }
    if (value.length < 3) return;

    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };

  const imprimirReporte = (sql, titulo) => {
    try {
      window.open(
        op.reportes +
          "/inmueblesurbanos?" +
          "reporte=ListGenInmueble" +
          "&sql= " +
          sql +
          " " +
          "&sql3= and " +
          sql +
          "&sql2=" +
          titulo +
          "&tipo=",
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Imprimir el Reporte",
        icono: "error",
      });
    }
  };

  useEffect(() => {
    buscarRegistrosCartas();
    seleccionarConfiguracion();
    seleccionarValorPetro();
    seleccionarConfigInmueble();
  }, []);

  useEffect(() => {
    buscarRegistros();
  }, [tableState.page, tableState.rowsPerPage, tableState.search]);

  return (
    <div
      className="container-fluid p-4"
      style={{
        backgroundColor: "#f0f2f5",
        height: "100dvh",
        paddingTop: "1%",
      }}
    >
      <div className="row g-4 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-4 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <span
                      className="text-uppercase small fw-bold opacity-75"
                      style={{ letterSpacing: "2px" }}
                    >
                      {card.title}
                    </span>
                    <h2
                      className="fw-bold mb-0 mt-1"
                      style={{ fontSize: "2.5rem" }}
                    >
                      {card.value}
                    </h2>
                  </div>
                  <i
                    className={card.icon}
                    style={{ color: card.iconColor }}
                  ></i>
                </div>

                {card.print && (
                  <div
                    className="mt-2"
                    style={{ position: "relative", zIndex: 10 }}
                  >
                    <button
                      onClick={card.print}
                      className="btn btn-sm btn-light rounded-circle p-2"
                      style={{ width: "35px", height: "35px" }}
                    >
                      <i className="fas fa-print"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-between">
        <div className="col-md-8 m-0 p-2 rounded border">
          <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light rounded-top azulGradiant">
            <h3 className="fw-bold m-0">
              Gestion de Contribuyentes Inmuebles Urbanos
            </h3>
          </header>

          <div className="col-4 m-0 my-2 p-0">
            <SearchInput
              placeholder="Buscar"
              value={searchInput}
              onChange={handleSearch}
            />
          </div>

          <div className="col-12 m-0 p-0">
            <TblContainer>
              <TblHead />
              <tbody>
                {records &&
                  records.map((item, index) => (
                    <tr key={item.idinmueble} style={{ padding: "0" }}>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                          width: "10px",
                        }}
                      >
                        {item.idinmueble}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                          width: "80px",
                        }}
                      >
                        {item.numficha}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "10px",
                          textAlign: "left",
                          width: "150px",
                        }}
                      >
                        {item.nombrepropie}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "10px",
                          textAlign: "left",
                          width: "auto",
                        }}
                      >
                        {item.dirinmueble}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "10px",
                          textAlign: "left",
                          width: "140px",
                        }}
                      >
                        {item.codigocatastral}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                          width: "145px",
                        }}
                      >
                        {item.cedulapropie}
                      </td>
                      <td
                        className="align-baseline"
                        align="center"
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                          width: "100px",
                        }}
                      >
                        {/* Botón VER */}
                        <button
                          onClick={seleccionarRegistro(
                            1,
                            item.idinmueble,
                            permiso.toString().substring(0, 1),
                          )}
                          className={
                            permiso.toString().substring(0, 1) === "1"
                              ? "btn btn-sm btn-info rounded-circle"
                              : "btn btn-sm btn-secondary rounded-circle"
                          }
                          title="Ver detalle"
                        >
                          <i className="fas fa-eye"></i>
                        </button>
                        <span> </span>
                        {/* Botón EDITAR */}
                        <button
                          onClick={seleccionarRegistro(
                            2,
                            item.idinmueble,
                            permiso.toString().substring(1, 2),
                          )}
                          className={
                            permiso.toString().substring(1, 2) === "1"
                              ? "btn btn-sm btn-warning rounded-circle"
                              : "btn btn-sm btn-secondary rounded-circle"
                          }
                          title="Editar"
                        >
                          <i className="fa fa-edit"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
            <TblPagination />
          </div>
        </div>

        <div className="col-md-4">
          <div
            className="card shadow-1-strong d-flex align-items-center justify-content-center"
            style={{ borderRadius: "15px", minHeight: "500px" }}
          >
            <div className="text-center p-4">
              <img
                src={logoac}
                alt="Dashboard Illustration"
                className="img-fluid"
                style={{
                  maxHeight: "500px",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <ContribuyenteInmueble
        show={mostrarModal}
        deuda={deuda}
        historico={historico}
        tabmulta={multas}
        avaluoC={avaluo}
        usoTerreno={usoTerreno}
        onHideCancela={cerrarModal}
        valorConstruccion={valorConstruccion}
        inmueble={inmueble}
        valorUT={valorUT}
        configInmueble={configInmueble}
        periodo={prd}
        numpago={np}
        np={np}
        prd={prd}
        declaweb={declaWeb}
        options={options}
        onHideRenderizar={seleccionarDeuda}
        facturaR={facturaR}
        credito={credito}
        idValor={idValor}
        factorCambio={factorCambio?.valor}
      />

      <ModalActualizarAvaluo
        show={mostrarModalAvaluo}
        inmueble={inmueble}
        valorUT={factorCambio?.valor}
        onHideCancela={cerrarModalAvaluo}
        operacion={1}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <Dimmer active={activate || loading || loadingCard} inverted />
    </div>
  );
}
